import { render } from "./QueryIssue.vue?vue&type=template&id=75e9610b&scoped=true"
import script from "./QueryIssue.vue?vue&type=script&lang=js"
export * from "./QueryIssue.vue?vue&type=script&lang=js"

import "./QueryIssue.vue?vue&type=style&index=0&id=75e9610b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e9610b"]])

export default __exports__